import React from "react";
import {ListActionProvider} from "@beeldit/ecommerce/categories/actions/list/ListActionContext";
import {EditActionProvider} from "@beeldit/ecommerce/categories/actions/edit/EditActionContext";
import {RemoveActionProvider} from "@beeldit/ecommerce/categories/actions/remove/RemoveActionContext";
import {CreateActionProvider} from "@beeldit/ecommerce/categories/actions/create/CreateActionContext";
import CategoriesPage from "@beeldit/ecommerce/categories/pages/CategoriesPage";



export default function CategoriesRouterWrapper(props: { filters?: any, formDefaultValues?: any, formFilterValues?: any }) {
    const { filters, formDefaultValues, formFilterValues } = props;
    return (
      <ListActionProvider>
          <EditActionProvider>
              <RemoveActionProvider>
                  <CreateActionProvider>
                      <CategoriesPage filters={filters} formDefaultValues={formDefaultValues} formFilterValues={formFilterValues} />
                  </CreateActionProvider>
              </RemoveActionProvider>
          </EditActionProvider>
      </ListActionProvider>
    );
};
